import { InputGroupV2, TextInputV2, ValidationMessage } from '@equip.health/ui';

import { GROUP_CLASS_TITLE_LIMIT } from '~/lib/constants/calendar.constants';
import { ValidationType } from '~/lib/constants/enumeration.constants';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

export const GroupClassTitleField = ({
  value,
  isDisabled,
  onChange,
  isEditMode,
}: GroupClassBaseFieldProps<string>) => {
  const isInvalid = isEditMode && value?.length === 0;
  const isLengthy = value?.length > GROUP_CLASS_TITLE_LIMIT;

  const errorMessage = isLengthy
    ? `Title character limit is ${GROUP_CLASS_TITLE_LIMIT}`
    : null;

  const props = {
    isDisabled,
    isInvalid,
    value,
  };

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__title`}
      isRequired
      label="Title"
      shouldShowAsteriskWhenRequired
    >
      <TextInputV2
        {...props}
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__title-v2`}
        isInvalid={isInvalid || isLengthy}
        onChange={(value) => onChange(value)}
      />
      {errorMessage && (
        <ValidationMessage
          id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__title-error`}
          type={ValidationType.CRITICAL}
          value={errorMessage}
        />
      )}
    </InputGroupV2>
  );
};
